module.exports = __webpack_public_path__ + "static/media/coliseu_porto_ageas_circo_2018_04.ac1d9c7b.jpg";